module.exports = __webpack_public_path__ + "static/media/24-10.6d44b81a.mp3";